import type { TTargetKey } from './types';

export const getDetectorTypeFromTargets = (checks: Record<TTargetKey, boolean>): string => {
  const hasBody = checks.body;
  const hasOther = checks.face || checks.liveness || checks.deepfake;

  if (!hasBody) return 'face';
  if (!hasOther) return 'body';
  return 'human';
};
